import { Link } from 'react-router-dom';
import { liveSessions } from '@/mocks/lives';
import SectionHeading from '@/components/feature/SectionHeading';
import { formatCount } from '@/utils/time';

export default function HotRankSection() {
  const ranked = [...liveSessions].sort((a, b) => b.hot - a.hot).slice(0, 6);
  const maxHot = ranked[0]?.hot ?? 1;

  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="container-page">
        <SectionHeading
          eyebrow="热门直播推荐"
          title="热度每小时刷新一次，帮你先挑重点"
          desc="综合同时在线人数、互动频率与回放点播量计算热度，榜单随直播进行动态变化。"
        />

        <ol className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {ranked.map((session, index) => {
            const percent = Math.round((session.hot / maxHot) * 100);
            return (
              <li key={session.id}>
                <Link
                  to={`/live/${session.id}`}
                  className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-primary-300 md:p-4"
                >
                  <span
                    className={`w-7 shrink-0 text-center font-heading text-xl font-bold tabular-nums md:text-2xl ${
                      index < 3 ? 'text-accent-600' : 'text-foreground-300'
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span className="block h-[64px] w-[110px] shrink-0 overflow-hidden rounded-md bg-background-200">
                    <img
                      src={session.cover}
                      alt={`爆料直播网 - ${session.title} 直播封面`}
                      title={`${session.title} 热门直播推荐`}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="line-clamp-1 font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[15px]">
                      {session.title}
                    </h3>
                    <p className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                      <span className="rounded bg-secondary-100 px-2 py-0.5 font-medium text-secondary-900">
                        {session.category}
                      </span>
                      <span>{session.host}</span>
                      <span>{session.start} 开播</span>
                    </p>
                    <div className="mt-2 flex items-center gap-2">
                      <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                        <span
                          className="block h-full rounded-full bg-primary-500"
                          style={{ width: `${percent}%` }}
                        />
                      </span>
                      <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                        <span className="w-3.5 h-3.5 flex items-center justify-center">
                          <i className="ri-fire-line" aria-hidden="true" />
                        </span>
                        {formatCount(session.hot)}
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}